import {watch} from 'store/effects';

export function* theme() {
  yield watch(state => state.settings.theme, function* (theme) {
    window.document.body.classList.remove('light-theme', 'dark-theme');
    window.document.body.classList.add(theme + '-theme');
  });
}
